module.exports = __webpack_public_path__ + "static/media/Melissa3_preview.68322930.jpg";